import LegalPage from "@/components/LegalPage";

const CookiePolicy = () => (
  <LegalPage
    title="Cookie Policy"
    updated="luglio 2026"
    description="Informativa sull'uso dei cookie e delle tecnologie di tracciamento del sito ORIGINI Studio Olistico."
    url="/cookie-policy"
  >
    <p>
      Questa pagina descrive l'uso dei cookie e delle tecnologie simili sul sito, in
      conformità alle linee guida del Garante per la protezione dei dati personali.
    </p>

    <h2>Cosa sono i cookie</h2>
    <p>
      I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo
      dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla
      visita successiva.
    </p>

    <h2>Cookie tecnici</h2>
    <p>
      Il sito utilizza esclusivamente cookie tecnici necessari al corretto funzionamento
      (ad esempio per memorizzare le preferenze sul consenso ai cookie). Per questi cookie
      non è richiesto il consenso.
    </p>

    <h2>Cookie analitici e di terze parti</h2>
    <p>
      Previo tuo consenso, il sito può utilizzare strumenti di statistica (Google Analytics 4)
      per raccogliere informazioni aggregate sull'utilizzo del sito. Questi cookie vengono
      installati solo dopo l'accettazione tramite l'apposito banner e puoi revocare il
      consenso in qualsiasi momento.
    </p>
    <p>Il sito può inoltre incorporare contenuti di terze parti che utilizzano cookie:</p>
    <ul>
      <li>
        <strong>Google Maps</strong> — mappa della sede; consulta l'informativa di Google.
      </li>
      <li>
        <strong>Google Fonts</strong> — caratteri tipografici forniti da Google.
      </li>
    </ul>

    <h2>Gestione del consenso</h2>
    <p>
      Al primo accesso viene mostrato un banner che consente di accettare o rifiutare i
      cookie non tecnici. Puoi modificare la tua scelta cancellando i cookie dal browser o
      tramite le impostazioni del tuo browser, che permettono anche di bloccare o eliminare
      i cookie già installati.
    </p>

    <h2>Maggiori informazioni</h2>
    <p>
      Per il trattamento dei dati personali consulta la nostra{" "}
      <a href="/privacy">Privacy Policy</a>.
    </p>
  </LegalPage>
);

export default CookiePolicy;
